module.exports = __webpack_public_path__ + "img/misha2.85b16dca.jpg";